import { MemberType } from '@lucidlink/dto/validation';
const USER_LEGACY_KEY = '$User';
const ACCOUNT_KEY = '$Account';
export class SessionContext {
    storage;
    constructor(storage) {
        this.storage = storage;
    }
    async storeAccountDetails(account) {
        await this.storage.put(ACCOUNT_KEY, account);
    }
    async getAccountDetails() {
        const account = await this.storage.get(ACCOUNT_KEY);
        if (account) {
            return account;
        }
        const user = await this.storage.get(USER_LEGACY_KEY);
        if (user) {
            const account = {
                userId: user.id,
                email: user.email,
                type: MemberType.USER,
                eAccountKey: user.eUserKey,
                accountKeyGen: user.userKeyGen,
                wrappingKey: 'derivedKey' in user ? user.derivedKey : user.passwordKey,
            };
            await Promise.all([
                this.storeAccountDetails(account),
                this.storage.remove(USER_LEGACY_KEY),
            ]);
            return account;
        }
        return null;
    }
    async deleteAccountDetails() {
        await Promise.all([
            this.storage.remove(ACCOUNT_KEY),
            this.storage.remove(USER_LEGACY_KEY),
        ]);
    }
}
